import { Routes } from '@angular/router';
import { onboardingGuard } from './core/guards/onboarding.guard';

// TEMP-DESIGN-PREVIEW: these three imports and the route below them go together.
// Remove all four before committing.
import { AuthService } from './core/services/auth.service';
import { SubscriptionService } from './core/services/subscription.service';
import { authStub, subscriptionStub } from './pages/onboarding/profiling-page/design-preview.stub';

export const routes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/auth.routes').then((routes) => routes.AuthRoutes),
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./payment/payment.routes').then((routes) => routes.PaymentRoutes),
    canActivate: [onboardingGuard],
  },
  {
    // Public sales-assisted payment (no auth): /pay?token=… and /pay/status
    path: 'pay',
    loadChildren: () =>
      import('./genie-pay/genie-pay.routes').then((m) => m.GeniePayRoutes),
  },
  {
    // The sign-up popup the marketing site opens. No guard: the visitor has no
    // account yet, and after a Dhan round trip it resumes signed in.
    path: 'embed/signup',
    loadComponent: () =>
      import('./embed/embed-signup.component').then((m) => m.EmbedSignupComponent),
  },
  {
    // Where Google sends the sign-up popup back. Must be listed as an
    // authorised redirect URI on the OAuth client in Google Cloud Console.
    path: 'embed/google-callback',
    loadComponent: () =>
      import('./embed/google-callback.component').then((m) => m.GoogleCallbackComponent),
  },
  {
    // Where a marketing sign-up lands, already signed in.
    path: 'welcome',
    loadComponent: () =>
      import('./embed/welcome.component').then((m) => m.WelcomeComponent),
    canActivate: [onboardingGuard],
  },
  {
    path: 'subscriptions',
    loadChildren: () =>
      import('./subscription/subscscription.routes').then((m) => m.PaymentRoutes),
  },
  {
    // TEMP-DESIGN-PREVIEW: unguarded render of the onboarding page so it can be
    // screenshotted without a session. Remove before committing.
    path: 'design-preview/onboarding',
    loadComponent: () =>
      import('./pages/onboarding/profiling-page/profiling-page.component')
        .then((m) => m.ProfilingPageComponent),
    providers: [
      { provide: AuthService, useValue: authStub },
      { provide: SubscriptionService, useValue: subscriptionStub },
    ],
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages.routes').then((routes) => routes.PageRoutes),
    canActivate: [onboardingGuard],
    // profilingGuard is not here: it is canActivateChild on the layout route in
    // pages.routes.ts, which is the only place that catches sibling-to-sibling
    // navigation. See the comment there.
    // subscriptionGuard is intentionally not stacked here: the onboarding gate
    // decides whether an account is usable, entitlement is a separate question.
  },
];
